import React, { useEffect, useState } from "react";
import InvestorViewBaseForm from "../../createInvestors/investorViewBaseForm";
import "./styles/index.scss";
import * as api from "../../../../api/generated-api";
import { processUnexpectedError } from "../../../../api/errors";

type ViewInvestorProps = {
  organizationId: number;
  dealId: number;
  investor: api.DealInvestor;
  onInvestorOpen: (focus?: boolean) => void;
};

const ViewInvestor = ({
  organizationId,
  dealId,
  investor,
  onInvestorOpen,
}: ViewInvestorProps) => {
  const [dealLegalEntityInvestments, setDealLegalEntityInvestments] = useState<
    api.DealLegalEntityInvestment[]
  >([]);

  useEffect(() => {
    const fetchDealLegalEntityInvestments = async () => {
      const result = await api.getDealInvestorDealLegalEntityInvestments(
        organizationId,
        dealId,
        investor.id
      );
      setDealLegalEntityInvestments(result.data);
    };

    if (investor) {
      fetchDealLegalEntityInvestments().catch((error) => {
        processUnexpectedError(error);
      });
    }
  }, []);

  const handleClickOnAvatar = (e) => {
    e.stopPropagation();
    onInvestorOpen();
  };

  return (
    <div
      className="investor-container"
      data-testid="row-investor"
      onClick={(e) => handleClickOnAvatar(e)}
    >
      <div className="investor-description-container">
        <InvestorViewBaseForm
          investor={investor}
          dealLegalEntityInvestments={dealLegalEntityInvestments}
          clickToAvatar={(e) => handleClickOnAvatar(e)}
        />
      </div>
    </div>
  );
};

export default ViewInvestor;
